
import './Css/App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SideBar from './Components/SideBar/SideBar';
import Darkmode from './Components/DarkMode/Darkmode';
import Component from './Components/Component/Component';
import Login from './Components/Authentication/Login';
import Register from './Components/Authentication/Register';
import Forgot from './Components/Authentication/ForgotPassword';
import ResetPassword from './Components/Authentication/ResetPassword';
import Sucess from './Components/Authentication/Sucess';
import Assistant from './Components/Assistant/Assistant';
import CreateAssistant from './Components/Assistant/CreateAssistant';
import ComponentsUi from './Components/Component/ComponentsUi';
import ContactList from './Components/ContactList/ContactList';
import ContactListTable from './Components/ContactList/ContactListTable';
import Contact1 from './Components/ContactList/Contact1';
import Campaign from './Components/Campaign/Campaign';
import CreateCampaign from './Components/Campaign/CreateCampaign';
import CampaignOverview from './Components/Campaign/CampaignOverview';
import PhoneNumber from './Components/PhoneNumber/PhoneNumber';
import CallHistory from './Components/CallHistory/CallHistory';
import Integration from './Components/Integration/Integration';
import CreateVoicechatHome from './Components/CreateVoicechat/CreateVoicechatHome';
import Train from './Components/CreateVoicechat/Train';
import EditProfile from './Components/EditProfile/EditProfile';
import Error404 from './Components/Error/Error404';
import UnderMaintenance from './Components/Error/UnderMaintenance';
import Billing from './Components/Billing/Billing';
import Pricing from './Components/Pricing/Pricing';
import Support from './Components/Support/Support';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './utils/PrivateRoute';
import CampaignDetails from './Components/Campaign/CampaignDetails';
import CampaignCompleted from './Components/Campaign/CampaignCompleted';
import PhoneNumberHome from './Components/PhoneNumber/PhoneNumberHome';
import Otp from './Components/Authentication/Otp';
import AccountVerify from './Components/Authentication/AccountVerify';
import API from './Components/APIDeveloper/APIDeveloper'
import UserLayout from './Components/Layout/UserLayout';


function App() {

  return (
    <div className="App">
  
        <Router>
        {/* <AuthProvider> */}
          <Routes>
            <Route exact path="/darkmode" element={<Darkmode />} />
            {/* <Route path='/sidebar' element={<AuthProvider><SideBar/></AuthProvider>}></Route> */}
            <Route path='/component' element={<AuthProvider><Component/></AuthProvider>}/>
            <Route path='/components1' element={<AuthProvider><ComponentsUi/></AuthProvider>} />

            {/* Authentication */}
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<Register />} />
            <Route path='/forgot' element={<Forgot />} />
            <Route path='/reset' element={<ResetPassword />} />
            <Route path='/success' element={<Sucess />} />
            <Route path='verify' element={<Otp/>}/>
            <Route path='accountVerify' element={<AccountVerify/>}/>

          <Route element={<AuthProvider><UserLayout/></AuthProvider>}>
          
     
            <Route path='/' element={<AuthProvider><Assistant/></AuthProvider>}  />
            <Route path='/createassistant' element={<AuthProvider><CreateAssistant/></AuthProvider>} />
     

            {/* contact-list */}
            <Route path='/contact-list' element={<AuthProvider><ContactList/></AuthProvider>} />
            <Route path='/contact-list-table'element={<AuthProvider><ContactListTable/></AuthProvider>} />
            <Route path='/contact-list-view' element={<AuthProvider><Contact1/></AuthProvider>} />

            {/* campaign */}
            <Route path='/campaign' element={<AuthProvider><Campaign/></AuthProvider>}/>
            <Route path='/create-campaign' element={<AuthProvider><CreateCampaign/></AuthProvider>} />
            <Route path='/campaign-overview' element={<AuthProvider><CampaignOverview/></AuthProvider>}/>
            <Route path='/campaign-completed' element={<AuthProvider><CampaignCompleted/></AuthProvider>} />
            <Route path='/campaign-details' element={<AuthProvider><CampaignDetails /></AuthProvider>} />
            
            {/* Phone Number */}
            <Route path='/phone-number' element={<AuthProvider><PhoneNumber/></AuthProvider>}/>
            <Route path='/phone-number-home' element={<AuthProvider><PhoneNumberHome/></AuthProvider>} />

            {/* call History */}
            <Route path='/call-history' element={<AuthProvider><CallHistory/></AuthProvider>} />

            {/* Integration */}
            <Route path='/integration' element={<AuthProvider><Integration/></AuthProvider>} />

            {/* Create Voice chat */}
            {/* <Route path='/' element={ <PrivateRoute><CreateVoicechatHome/></PrivateRoute>} /> */}
            <Route path='/train' element={<AuthProvider><Train/></AuthProvider>}/>

            {/* EditProfile */}
            <Route path='/profile' element={<AuthProvider><EditProfile/></AuthProvider>}/>

            {/* Billing */}
            <Route path='/billing' element={<AuthProvider><Billing/></AuthProvider>} />

            {/* Pricing */}
            <Route path='/pricing' element={<AuthProvider><Pricing/></AuthProvider>} />
            {/* Support */}
            <Route path='/support' element={<AuthProvider><Support/></AuthProvider>} />

            {/* Error404 */}
            <Route path='/*' element={<Error404 />} />
            <Route path='/maintenance' element={<AuthProvider><UnderMaintenance/></AuthProvider>}/>

            {/* APIDeveloper */}
            <Route path='/api-developer' element={<AuthProvider><API /></AuthProvider>} />
            </Route>

          </Routes>
          {/* </AuthProvider> */}
        </Router>
 
    </div>
  );
}

export default App;
